module.exports = __webpack_public_path__ + "img/water-2-1.51c82044.png";